import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { MailMessage_Interface } from 'src/app/Interface/MailMessage_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MailMessageService {
  constructor(private http:HttpClient) { }


  GetRecord(Token:String,LetterType:number):Observable<Array<MailMessage_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Mailmessage?token="+Token+"&LetterType="+LetterType).pipe(
      map(data=>{
        return data as Array<MailMessage_Interface>
      })
    )
  }



  GetSingle(Token:String,id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Mailmessage/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddMail_Message(model: General_Interface,letterType:number,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      dsc:model.code,
      username:Token,
      letterType:letterType,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Mailmessage/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditMail_Message(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      dsc:model.code,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Mailmessage/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteMail_Message(id:number,Token:String):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Mailmessage/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  PishPardakht(id:number,Token:String):Observable<General_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Mailmessage/PishPardakht?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as General_Interface
      })
    )

}

  }
